// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__-U7CH","location":"Header_location__UEh3A"};